import React from 'react';
import { useStaticQuery, graphql } from "gatsby"
import { OfficeBaseURL } from './utils';
import { Link } from "gatsby"
import {GetPropertyOffice} from '../queries/common_use_query';
const GetBranch = (props) => {
  const {loading:loading, error:error, data:data} = GetPropertyOffice(props.officecrm);
  return (          
    <React.Fragment>        
        {data && data.ourOffices.slice(0, 1).map((office,index) => {
            return<>
            <div className="contact-branch-info">
                <span className="contact-branch">
                {/* {hit.area} Branch */}
                <Link to={`${OfficeBaseURL}${office.URL}`}>
                    <span>{office.Name} Branch</span> 
                </Link></span>{" "}
                              •
                <a href={`tel: ${props.searchtype === "lettings"?office.Lettings_Phone_Number:office.Sales_Phone_Number}`} className="contact-branch-number">                        
                {props.searchtype === "lettings"?office.Lettings_Phone_Number:office.Sales_Phone_Number}
                </a>
            </div>
                
            </>
        })}        
    </React.Fragment>
    )
};
export default GetBranch;
